import { PrimaryButton } from '@repo/ui/components/buttons/PrimaryButton';
import { SecondaryButton } from '@repo/ui/components/buttons/SecondaryButton';
import SuccessIcon from '@repo/ui/components/icons/SuccessIcon';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@repo/ui/components/dialog';
import { cn } from '../../lib/utils';

interface Props {
    open: boolean;
    onAddAnother: () => void;
    onReturnToList: () => void;
    text1: string;
    text2: string;
    textButton1: string;
    textButton2: string;
}

const SuccessPopup = ({ open, onAddAnother, onReturnToList, text1, text2, textButton1, textButton2 }: Props) => {
    return (
        <Dialog open={open}>
            <div
                className={cn('fixed inset-0 bg-black/50 z-[999]', {
                    '!hidden': !open,
                })}
            />
            <DialogContent
                showCloseButton={false}
                className="z-[1000] max-w-lg rounded-lg p-6 bg-white-blue-50 font-cairo gap-0 [&_[aria-label=Close]]:opacity-0"
            >
                <DialogHeader className="flex flex-col items-center">
                    <SuccessIcon className="text-green-success-600 text-center mb-[10px]" />
                    <DialogTitle className="text-center text-green-success-600 font-bold text-[22px] leading-[33px] tracking-normal">
                        {text1}
                    </DialogTitle>
                </DialogHeader>

                <div className="mt-2 mb-6 text-center text-[#6B7280] font-medium text-[14px] leading-[28px] tracking-normal">
                    <p>{text2}</p>
                </div>

                <div className="flex flex-row gap-3">
                    <PrimaryButton
                        onClick={onReturnToList}
                        className="w-full text-base leading-5 tracking-normal font-medium py-[10px]"
                    >
                        {textButton1}
                    </PrimaryButton>
                    <SecondaryButton
                        onClick={onAddAnother}
                        className="w-full text-base leading-5 tracking-normal py-[10px] font-medium"
                    >
                        {textButton2}
                    </SecondaryButton>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default SuccessPopup;
